import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DemurrageFormRoutingModule } from './demurrage-form-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DemurrageFormComponent } from './demurrage-form.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from "@angular/material/icon";
import { MatAutocompleteModule } from "@angular/material/autocomplete";



@NgModule({
  declarations: [
    DemurrageFormComponent
  ],
  imports: [
    CommonModule,
    DemurrageFormRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatIconModule,
    MatAutocompleteModule
],
  exports:[
    DemurrageFormComponent
  ]
})
export class DemurrageFormModule { }
